__webpack_require__.p = "https://cdn.brandwatch.com/shared-dashboard-wrapper/ddde6d04ae34b35d7816568664e2afbd1969f908/";